var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"information__field"},[_c('span',{staticClass:"information__field__label"},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]})],2),_c('span',{staticClass:"information__field__value"},[_vm._t("value",function(){return [_vm._v(_vm._s(_vm.value))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }